"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var SfilterLayoutAction;
(function (SfilterLayoutAction) {
    SfilterLayoutAction.ON_TOGGLE_LAYOUT_SECTION = 'ON_TOGGLE_LAYOUT_SECTION';
    SfilterLayoutAction.TOGGLE_LAYOUT_SECTION = 'TOGGLE_LAYOUT_SECTION';
    SfilterLayoutAction.TOGGLE_LAYOUT_OPTION = 'TOGGLE_LAYOUT_OPTION';
    SfilterLayoutAction.CHANGE_LAYOUT_OPTION = 'CHANGE_LAYOUT_OPTION';
    SfilterLayoutAction.toggleLayoutSection = typesafe_actions_1.createAction(SfilterLayoutAction.TOGGLE_LAYOUT_SECTION, function (resolve) { return function (state) { return resolve(state); }; });
    SfilterLayoutAction.onToggleLayoutSection = typesafe_actions_1.createAction(SfilterLayoutAction.ON_TOGGLE_LAYOUT_SECTION, function (resolve) { return function () { return resolve(); }; });
    SfilterLayoutAction.onToggleLayoutOption = typesafe_actions_1.createAction(SfilterLayoutAction.TOGGLE_LAYOUT_OPTION, function (resolve) { return function (key) { return resolve(key); }; });
    SfilterLayoutAction.changeLayoutOption = typesafe_actions_1.createAction(SfilterLayoutAction.CHANGE_LAYOUT_OPTION, function (resolve) {
        return function (key, state) { return resolve({ key: key, state: state }); };
    });
})(SfilterLayoutAction || (SfilterLayoutAction = {}));
exports.default = SfilterLayoutAction;
